import {
  CompanyInUser,
  CompanySort,
  EndUserSort,
  Language,
  ParkingSort,
  RoleSort,
  UserSort,
  UserStatus,
  UserType,
  UserTypeId,
} from "helpers";

export const LANGUAGES: Language[] = ["EN", "MK", "AL"];

export const COMPANIES: CompanyInUser[] = [
  {
    id: 1,
    company_id: "elektros-oftb-111a-222b-334455c66d77",
    name: "Elektrosoft",
  },
  {
    id: 2,
    company_id: "mkhostmk-00tb-111a-222b-334455c66d77",
    name: "MKHost",
  },
  {
    id: 3,
    company_id: "hoyotech-00tb-111a-222b-334455c66d77",
    name: "HoyoTech",
  },
];

export const CREATE_USER_TYPES: UserType[] = [
  {
    id: 2,
    name: "Super Admin",
  },
  {
    id: 3,
    name: "Admin",
  },
];

const USER_TYPES: { [key: number]: string } = {
  1: "Master Admin",
  2: "Super Admin",
  3: "Admin",
};

export const isMasterAdmin = (id: UserTypeId) => id === 1;
export const isSuperAdmin = (id: UserTypeId) => id === 2;
export const isAdmin = (id: UserTypeId) => id === 3;

export const getUserTypeName = (id: UserTypeId) => USER_TYPES[id];

export const FILTER_USER_TYPE: UserType[] = [
  {
    id: 1,
    name: "Master",
  },
  {
    id: 2,
    name: "Super",
  },
  {
    id: 3,
    name: "Admin",
  },
  {
    id: undefined!,
    name: "All",
  },
];

export const STATUSES: UserStatus[] = [
  {
    id: 1,
    name: "Active",
  },
  {
    id: 0,
    name: "Inactive",
  },
  {
    id: undefined!,
    name: "All",
  },
];

export const USER_SORTS: UserSort[] = [
  {
    id: "latest",
    name: "sorting.latest",
  },
  {
    id: "name-a-z",
    name: "sorting.nameAsc",
  },
  {
    id: "name-z-a",
    name: "sorting.nameDesc",
  },
  {
    id: "company-a-z",
    name: "sorting.companyAsc",
  },
  {
    id: "company-z-a",
    name: "sorting.companyDesc",
  },
  {
    id: "last-login",
    name: "sorting.lastSignIn",
  },
];

export const END_USER_SORTS: EndUserSort[] = [
  {
    id: "latest",
    name: "sorting.latest",
  },
  {
    id: "name-a-z",
    name: "sorting.nameAsc",
  },
  {
    id: "name-z-a",
    name: "sorting.nameDesc",
  },
  {
    id: "last-login",
    name: "sorting.lastSignIn",
  },
];

export const COMPANY_SORTS: CompanySort[] = [
  {
    id: "latest",
    name: "sorting.latest",
  },
  {
    id: "name-a-z",
    name: "sorting.nameAsc",
  },
  {
    id: "name-z-a",
    name: "sorting.nameDesc",
  },
  {
    id: "company-a-z",
    name: "sorting.companyAsc",
  },
  {
    id: "company-z-a",
    name: "sorting.companyDesc",
  },
  {
    id: "last-login",
    name: "sorting.lastSignIn",
  },
];

export const PARKING_SORTS: ParkingSort[] = [
  {
    id: "latest",
    name: "sorting.latest",
  },
  {
    id: "name-a-z",
    name: "sorting.nameAsc",
  },
  {
    id: "name-z-a",
    name: "sorting.nameDesc",
  },
  {
    id: "company-a-z",
    name: "sorting.companyAsc",
  },
  {
    id: "company-z-a",
    name: "sorting.companyDesc",
  },
  {
    id: "last-login",
    name: "sorting.lastSignIn",
  },
];

export const ROLE_SORTS: RoleSort[] = [
  {
    id: "latest",
    name: "sorting.latest",
  },
  {
    id: "name-a-z",
    name: "sorting.nameAsc",
  },
  {
    id: "name-z-a",
    name: "sorting.nameDesc",
  },
];

export const getCompanyName = (company: CompanyInUser, maxLength: number = 20): string => {
  const companyName = company.name || company.company_id; // Use company_id instead of id
  return companyName.length > maxLength ? `${companyName.slice(0, maxLength)}...` : companyName;
};
